// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"382":"aa5f7dce","484":"fde18fd9","604":"d6df0383","889":"504617ce"}[chunkId] + ".chunk.css";
};